import React from "react";
import "../componentStyle/Loader.css";
import { useTheme } from "../contexts/ThemeContext";

const Loader = ({ message }) => {
    const { isDarkTheme } = useTheme();
    
    return (
        <div className={`join-loader ${isDarkTheme ? 'dark' : ''}`}>
            <div className="loader-row">
                <div className="loader"></div>
                {message && <p className="loader-text">{message}</p>}
            </div>
        </div>
    );
};

export default Loader;
